// extracted by mini-css-extract-plugin
module.exports = {"noteText":"TypeOfFmStep_noteText__2BHMA"};